const getCorporationNameFromWorkRequest = (
  corporation: {
    companyLegalName?: string;
    companyLegalName2?: string;
    companyLegalName3?: string;
    companyNameSuffix?: string;
  },
  namePreference:
    | 'companyLegalName'
    | 'companyLegalName2'
    | 'companyLegalName3' = 'companyLegalName'
) => {
  if (!corporation) return '';
  const companyName = corporation[namePreference];

  if (!companyName) return '';
  return `${companyName} ${corporation.companyNameSuffix || ''}`?.trimEnd();
};

const getCorporationName = (
  corporation: {
    companyLegalName?: string;
    companyLegalName2?: string;
    companyLegalName3?: string;
    companyNameSuffix?: string;
  },
  namePreference:
    | 'companyLegalName'
    | 'companyLegalName2'
    | 'companyLegalName3' = 'companyLegalName'
) => {
  if (!corporation) return '';
  const companyName = corporation[namePreference];

  if (!companyName) return '';
  return `${companyName}`?.trimEnd();
};

export { getCorporationName, getCorporationNameFromWorkRequest };
